import React, { Component } from 'react';
import { Motion, spring } from 'react-motion';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';

import { startAddInterval } from '../../../store/actions/projects';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  listItem: {
    display: 'flex',
    padding: '5px 0px',
  },
});

class InvoiceTabs extends Component{
  constructor(props) {
    super(props);

    this.state = {
      selectedYear: (new Date()).getFullYear(),
      anchorEl: null,
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, project, selectedItem, handleSelect, startAddInterval } = this.props;
    const schedule = project.schedule;
    return(
      <div className={classes.root}>
        <Button
          color="primary"
          onClick={() => {
            //TODO: refactor. Another hack to get intervals to be named sequentially
            const intervals = Object.entries(project.intervals).map((interval) => {
              return {id: interval[0], ...interval[1]};
            });
            startAddInterval(project.id, {name: `Milestone ${intervals.length - 1}`});
          }}
        >
          Add
        </Button>
        <Divider />
        <List className={classes.content}>
          {schedule.map((scheduleItem, i) => {
            const isSelected = selectedItem === undefined ? false : scheduleItem.id === selectedItem.id;
            return(
              <List className={classes.listItem} key={i}>
                <ListItem button dense onClick={() => handleSelect(scheduleItem)}>
                  <ListItemText primary={scheduleItem.displayName} />
                </ListItem>
                { isSelected &&
                  <Motion defaultStyle={{x: -20, y: -20, opacity: 0}}
                          style={{
                            x: spring(0),
                            y: spring(0),
                            opacity: spring(1, { stiffness: 10, damping: 10})
                          }}>
                    {(style) => (
                      <div style={{
                          opacity: style.opacity,
                          borderRight: '3px solid #3f50b5'
                      }}/>
                    )}
                  </Motion>
                }
              </List>
            );
          })}
        </List>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startAddInterval: (projectId, interval) => dispatch(startAddInterval(projectId, interval))
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(InvoiceTabs);



// WEBPACK FOOTER //
// ./src/components/admin/Project/InvoiceTabs.jsx